import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { FiltersFormProvince } from './types';

export const transformDataset = (values: FiltersFormProvince): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codice: {
      value: otherValues.code,
      operation: Operation.EQUALS,
    },
    nome: {
      value: otherValues.name,
    },
    codRegione: {
      value: otherValues.region,
      operation: Operation.EQUALS,
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    codice: ordersToTransform.code,
    nome: ordersToTransform.name,
    regione: ordersToTransform.region,
  };

  return `?${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
